export default __webpack_public_path__ + "static/media/empty-plate-background.40ee5aad.jpg";